let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fcXn9")).then(() => parcelRequire('4IbNl'));